// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xf8P","tabsBox":"styles_tabsBox__G3SSX","createButton":"styles_createButton__1nVek"};